import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'page.paymentByLink.pageUnavailable';
export const LABELS = makeLabels(
  {
    PAGE_UNAVAILABLE_MESSAGE: [
      'message',
      'The Payment by Link feature will be available once your account is activated.<br/><br/>' +
        'Please contact our support if you have any questions.',
    ],
  },
  NAMESPACE,
);

export default LABELS;
